import React from "react";
import { CHART_RESOLUTIONS } from "../../../settings/effectiveChartSettings";
import { resolutionToLabel } from "../../../constants";

/**
 * Grid of resolution buttons.
 *
 * @param {object} props
 * @param {string}   props.activeResolution - current TV resolution string
 * @param {Function} props.onSelect         - (resolution: string) => void
 */
const ResolutionGrid = ({ activeResolution, onSelect }) => (
  <div className="chart-type-menu__resolutions-grid">
    {CHART_RESOLUTIONS.map((res) => (
      <button
        key={res}
        type="button"
        className={`chart-type-menu__resolution-btn${activeResolution === res ? " chart-type-menu__resolution-btn--active" : ""}`}
        onClick={() => onSelect(res)}
        aria-pressed={activeResolution === res}
      >
        {resolutionToLabel(res)}
      </button>
    ))}
  </div>
);

export default ResolutionGrid;
